/* eslint-disable no-undef */
export async function getPrime(env, hashkey) {
	const sdk = typeof window !== 'undefined' ? window.NewebPaySDK : undefined;
	if (!sdk) {
		return {
			value: null,
			error: true,
			message: 'NewebPaySDK is not defined',
		};
	}

	const r = await sdk.getPrime(env, hashkey);

	if (r.responseCode === '0000') {
		return {
			value: r.prime,
			error: false,
			message: null,
		};
	}

	console.error(`(${r.responseCode}): ${r.resMessage}`);
	return {
		value: null,
		error: true,
		message: r.resMessage,
	};
}
